import { MouseEventHandler, ReactNode } from "react";
import styles from "./PTab.module.scss";

type PTabTone = "primary" | "loyalty";

type PTabProps = {
  href?: string;
  id: string;
  isActive: boolean;
  onClick: MouseEventHandler<HTMLAnchorElement>;
  tone?: PTabTone;
  children: ReactNode;
};

export const PTab = ({
  href = "#",
  id,
  isActive,
  onClick,
  tone = "primary",
  children,
}: PTabProps) => (
  <a
    href={href}
    id={id}
    className={`${styles.p_tab} ${styles[tone]} ${
      isActive ? styles.active : ""
    }`}
    onClick={onClick}
  >
    {children}
  </a>
);
